import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  zoneList: [],
  zonesProviders: [],
  zoneInfo: {},
  states: [],
  counties: []
};
const zones = createSlice({
  name: 'zones',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        zoneList: action.payload?.result,
        count: action.payload?.count
      };
    },
    getById(state, action) {
      return {
        ...state,
        zoneInfo: action.payload
      };
    },
    getCounties(state, action) {
      return {
        ...state,
        counties: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || action.payload?.result || []
      };
    },
    clearCounties(state) {
      return {
        ...state,
        counties: []
      };
    },
    getStates(state, action) {
      return {
        ...state,
        states: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || action.payload?.result || []
      };
    },
    getProviders(state, action) {
      const transformedData = {
        primaryProviders: action.payload.primaryProviders
          ? action.payload.primaryProviders.map(
              ({ providerCompanyId, providerCompanyName }) => ({
                id: providerCompanyId,
                name: providerCompanyName
              })
            )
          : [],
        backupProviders: action.payload.backupProviders
          ? action.payload.backupProviders.map(
              ({ providerCompanyId, providerCompanyName }) => ({
                id: providerCompanyId,
                name: providerCompanyName
              })
            )
          : []
      };
      return {
        ...state,
        zonesProviders: transformedData
      };
    }
  }
});

export const zoneActions = zones.actions;

export const getZonesAction = (data) => async (dispatch) => {
  dispatch(zoneActions.setLoading(true));
  try {
    const res = await api.post(`api/zone/filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(zoneActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(zoneActions.setLoading(false));
  }
};

export const createZone = (data) => async () => {
  try {
    const res = await api.post(`api/zone`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const editZone = (data) => async () => {
  try {
    const res = await api.put(`api/zone`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const getZoneById = (id) => async (dispatch) => {
  dispatch(zoneActions.setLoading(true));
  try {
    const res = await api.get(`api/zone`, { params: { id } });
    if (res.status === 200 && res?.data) {
      dispatch(zoneActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(zoneActions.setLoading(false));
  }
};
export const getStates = () => async (dispatch) => {
  try {
    const res = await api.get(`api/State`);
    if (res.status === 200 && res?.data) {
      dispatch(zoneActions.getStates(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getCountiesByState = (stateId) => async (dispatch) => {
  try {
    const res = await api.get(`api/County/${stateId}`);
    if (res.status === 200 && res?.data) {
      dispatch(zoneActions.getCounties(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getZoneCounties = (id) => async (dispatch) => {
  try {
    const res = await api.get(`api/zone/counties`, { params: { id } });
    if (res.status === 200 && res?.data) {
      dispatch(zoneActions.getCounties(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getZoneProviders = (id) => async (dispatch) => {
  try {
    const res = await api.get(`api/zone/providers`, { params: { id } });
    if (res.status === 200 && res?.data) {
      dispatch(zoneActions.getProviders(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const clearZoneById = () => async (dispatch) => {
  dispatch(zoneActions.getById(''));
};

export const clearCounties = () => (dispatch) => {
  dispatch(zoneActions.clearCounties());
};

export const removeZoneAction = (id, setRemoveDialog) => async () => {
  try {
    const res = await api.delete(`api/zone`, { params: { id } });
    if (res.status === 200) {
      setRemoveDialog('');
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export default zones.reducer;
